import {
  COPY_ITEM_AND_CREATE_ITEM_SHARE_START,
  COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS,
  COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED,
  DELETE_ITEM_SHARE_START,
  DELETE_ITEM_SHARE_SUCCESS,
  DELETE_ITEM_SHARE_FAILED,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_START,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS,
  UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED,
} from 'chameleon-src/actionTypes';

import copyItemAndCreateItemShare from 'chameleon-src/utility/helpers/copyItemAndCreateItemShare';
import deleteItemShare from 'chameleon-src/utility/helpers/deleteItemShare';
import updateItemShareActive from 'chameleon-src/utility/helpers/updateItemShareActive';
import { toast } from 'chameleon/ui-stack/ui/toast';
import { renderItemShareCopyNotification } from 'chameleon-src/components/SharedAssessmentPage/utils';

export const copyItemAndCreateItemShareAction =
  (
    client,
    itemId,
    subjectId,
    shareKey,
    handleCloseModal,
    shouldCreateItemShareOnly = false,
    itemShareId,
    title = '',
  ) =>
  async (dispatch) => {
    dispatch({
      type: COPY_ITEM_AND_CREATE_ITEM_SHARE_START,
    });
    try {
      const response = await copyItemAndCreateItemShare(
        client,
        itemId,
        subjectId,
        shareKey,
        shouldCreateItemShareOnly,
        itemShareId,
        title,
      );
      dispatch({
        type: COPY_ITEM_AND_CREATE_ITEM_SHARE_SUCCESS,
        payload: response,
      });
      const { itemId: newItemShareItemId, title: newItemShareTitle } =
        response || {};
      handleCloseModal(newItemShareItemId);
      if (!shouldCreateItemShareOnly) {
        renderItemShareCopyNotification(
          newItemShareTitle,
          newItemShareItemId,
          subjectId,
        );
      }
    } catch (error) {
      dispatch({
        type: COPY_ITEM_AND_CREATE_ITEM_SHARE_FAILED,
        payload: { errorMessage: error.message },
      });
    }
  };

export const deleteItemShareAction =
  (client, itemShareId, handleCloseModal = () => {}) =>
  async (dispatch) => {
    dispatch({
      type: DELETE_ITEM_SHARE_START,
    });
    try {
      const response = await deleteItemShare(client, itemShareId);
      dispatch({
        type: DELETE_ITEM_SHARE_SUCCESS,
        payload: { itemShareId: response },
      });
      handleCloseModal();
      toast('The shared assessment has been removed.', {
        timeout: 10,
      });
    } catch (error) {
      dispatch({
        type: DELETE_ITEM_SHARE_FAILED,
        payload: { errorMessage: error.message },
      });
      toast(
        "The shared assessment couldn't be removed. Please try again later",
        {
          timeout: 5,
        },
      );
    }
  };

export const updateItemShareActiveStateAction =
  (client, oldItemId, status) => async (dispatch) => {
    dispatch({
      type: UPDATE_ITEM_SHARE_ACTIVE_STATE_START,
    });
    try {
      const response = await updateItemShareActive(client, oldItemId, status);
      dispatch({
        type: UPDATE_ITEM_SHARE_ACTIVE_STATE_SUCCESS,
        payload: { oldItemId: response },
      });
      toast('The shared quiz has been removed from the list.', {
        timeout: 10,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_ITEM_SHARE_ACTIVE_STATE_FAILED,
        payload: { errorMessage: error.message },
      });
      toast("The shared quiz couldn't be removed. Please try again later", {
        timeout: 5,
      });
    }
  };
